const getters = {
  visibleColumns: state => state.columns.filter(x => x.showColumn),
  selectableColumns: state => state.columns,
};

export default getters;
